module.exports = __webpack_public_path__ + "img/works_wechat_anpi_2.e86552ce.png";